import { compileDynamicRoute } from 'helper/string';
import PatchController from '../PatchController';

export default class ProgramPreviewController extends PatchController {
	public programUrl?: string;

	public prepare(done) {
		this.programUrl = compileDynamicRoute(this.routes.program.preview.href, {
			id: this.params.programId,
		});

		done();
	}

	public handle() {
		this.redirect(this.programUrl || this.routes.program.preview.href);
	}
}
